import Box from "@mui/material/Box";

export const VerticalDivider: React.FC = () => (
  <Box
    sx={{
      position: 'absolute',
      left: { md: 'calc(66.666667%)' },
      top: 0,
      bottom: 0,
      borderLeft: { md: "1px solid #ddd" },
      display: { xs: 'none', md: 'block' },
      mx: '-30px'
    }}
  />
);














